import { get, post } from "./http";

export const getNotifications = () => get("/common/notifications");
export const sendFeedback = (payload) => post("/common/feedback/log", payload);
export const sendHelpRequest = (payload) => post("/common/help/log", payload);
export const getNews = () => get("/common/news");

export const getChatList = () => get("/common/chatList");
export const getChatDetails = (userId, pageNo, bidRequestId) =>
	get(`/common/chatDetails/${userId}`, { pageNo: 0, limit: pageNo, bidRequestId });
export const sendChatMessage = (userId, payload) => post(`/common/chatDetails/${userId}`, payload);
